import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import Dialog from '../../components/UI/Dialog/Dialog'
import './index.scss'
import { updateSelectedLanguage } from '@/store/common/actions'
import i18n from '../UI/Internationalisation/i18n'
import { useTranslation } from 'react-i18next'

export const LANGUAGE_OPTIONS = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'pt-pt',
    label: 'Português - Portugal',
  },
  {
    value: 'id',
    label: 'Bahasa Indonesia',
  },
  {
    value: 'es',
    label: 'Español',
  },
  {
    value: 'tr',
    label: 'Türkçe',
  },
  {
    value: 'es-MX',
    label: 'Español - Mexico',
  },
  {
    value: 'ms',
    label: 'Bahasa Melayu',
  },
]

const ChangeLanguage = (props: any) => {
  const dispatch = useDispatch()
  const { t } = useTranslation('translation')
  const [selectedLanguage, setSelectedLanguage] = useState<string>('en')

  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem('selectedLanguageCode') || 'en',
  )

  useEffect(() => {
    if (currentLanguage) {
      i18n.changeLanguage(currentLanguage)
      setSelectedLanguage(currentLanguage)
    }
  }, [])

  const saveLanguageSetting = () => {
    dispatch(updateSelectedLanguage(selectedLanguage))
    setCurrentLanguage(selectedLanguage)
    i18n.changeLanguage(selectedLanguage)
    props.onHide()
  }

  return (
    <Dialog
      open={props.show}
      onClose={props.onHide}
      title={t('Change Language')}
      showCloseButton
      sx={{ width: '400px' }}
      footerActions={[
        {
          title: t('Close'),
          variant: 'outlined',
          onClick: props.onHide,
        },
        {
          title: t('Save Changes'),
          variant: 'contained',
          color: 'primary',
          onClick: saveLanguageSetting,
          disabled: selectedLanguage === currentLanguage,
        },
      ]}
    >
      <div className="tw-mb-4">
        <h3 className="tw-mb-2 tw-text-base tw-font-semibold">
          {t('View Page in')}
        </h3>
        <Select
          fullWidth
          value={selectedLanguage}
          onChange={(e: SelectChangeEvent) => {
            setSelectedLanguage(e.target.value)
          }}
        >
          {LANGUAGE_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </div>
    </Dialog>
  )
}

export default ChangeLanguage
